class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.summary = this.details.querySelector("summary");
    this.content = this.summary.nextElementSibling;

    this.onToggle = this.onToggle.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  disconnectedCallback() {
    this.details.removeEventListener("toggle", this.onToggle);
    this.details.removeEventListener("focusout", this.onFocusOut);
    this.summary.removeEventListener("click", this.onSummaryClick);
    document.removeEventListener("click", this.handleDocClick);
  }

  onSummaryClick(evt) {
    evt.stopPropagation();
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      document.addEventListener("click", this.handleDocClick);
      this.animations.forEach((animation) => animation.play());
    } else {
      document.removeEventListener("click", this.handleDocClick);
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  connectedCallback() {
    this.details.addEventListener("toggle", this.onToggle);
    this.details.addEventListener("focusout", this.onFocusOut);
    this.summary.addEventListener("click", this.onSummaryClick);
  }

  handleDocClick(event) {
    if (this.details.hasAttribute("open") && !this.contains(event.target)) {
      this.details.removeAttribute("open");
      this.summary.setAttribute("aria-expanded", "false");
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);
